import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  signal,
  viewChild,
} from '@angular/core';
import { GalleryLayout4 } from '@components/gallery/components/gallery-layout-4/model';
import { ResponsiveService } from '@services/responsive';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { IconsDirective } from '@shared/directives';
import { Image } from '@shared/models';

@Component({
  selector: 'app-gallery-layout-4',
  imports: [TitleComponent, IconsDirective, ImageComponent],
  templateUrl: './gallery-layout-4.component.html',
  styleUrl: './gallery-layout-4.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout4Component implements OnInit {
  readonly listElement = viewChild.required<ElementRef<HTMLElement>>('listElement');
  readonly data = input.required<GalleryLayout4>();
  title = signal<Title>(null!);
  subtitle = signal<Title>(null!);
  selectedItem = signal<{ image: Image; text: string; fullname: string; job: string }>(null!);
  currentScroll = signal(0);
  readonly breakpoints = inject(ResponsiveService).breakpoints;

  ngOnInit(): void {
    const data = this.data();
    if (data.title) {
      this.title.set({
        size: {
          desktop: 'H2',
          mobile: 'H2',
        },
        text: data.title,
        level: 'SPAN',
        color: 'BLACK',
      });
    }
    if (data.subtitle) {
      this.subtitle.set({
        size: {
          desktop: 'SPAN',
          mobile: 'SPAN',
        },
        type: 'SLASH',
        weight: 500,
        text: data.subtitle,
        level: 'H2',
        color: 'GREY_LIGHT',
      });
    }
  }

  onSelect(item: { image: Image; text: string; fullname: string; job: string }) {
    this.selectedItem.set(item);
  }

  onNext(length: number) {
    if (this.currentScroll() < this.listElement().nativeElement.clientWidth * (length - 1)) {
      this.currentScroll.set(this.currentScroll() + this.listElement().nativeElement.clientWidth);
    } else {
      this.currentScroll.set(0);
    }

    this.listElement().nativeElement.scrollTo({ left: this.currentScroll() });
  }

  onPrev(length: number) {
    if (this.currentScroll() > 0) {
      this.currentScroll.set(this.currentScroll() - this.listElement().nativeElement.clientWidth);
    } else {
      this.currentScroll.set(this.listElement().nativeElement.clientWidth * (length - 1));
    }
    this.listElement().nativeElement.scrollTo({ left: this.currentScroll() });
  }
}
